<div class="overlay">
  <div class="dialog">
    <section class="confirm-delete-container">
      <form (ngSubmit)="onSubmit()">
        <h2>{{ "firstTimeLogin.intro.request" | translate }}</h2>
        <h3>
          {{
            "First, click on the Send button to receive the OTP. After entering the OTP, type your desired password."
              | translate
          }}
        </h3>

        <app-otp-input
          [textControl]="this.requestOtpForm.controls.otp"
          (otpSend)="this.sendOtp()"
          identifier="first-time-login"
        ></app-otp-input>
        <br />
        <app-dialog-action-buttons
          [config]="{
            cancelButton: true,
            actionButton: true,
            actionButtonConfigs: {
            type: 'button',
            text: 'common.confirm' | translate,
            form: this.requestOtpForm
          },
          }"
        ></app-dialog-action-buttons>
      </form>
    </section>
  </div>
</div>
